import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import React from 'react';
import { useTranslation } from '@shared/utils/i18n';

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  message?: string | null;
}

export const ForceUpdateConfirmDialog: React.FC<Props> = ({ open, onClose, onConfirm, message }) => {
  const { t } = useTranslation();
  const [isConfirming, setIsConfirming] = React.useState(false);

  const handleConfirm = async () => {
    setIsConfirming(true);
    try {
      await onConfirm();
    } finally {
      setIsConfirming(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle sx={{ mb: 2 }}>{t('accruals:forceUpdateConfirm.title')}</DialogTitle>
      <DialogContent>
        <Box>
          <Typography sx={{ mb: 2 }}>{message || t('accruals:forceUpdateConfirm.defaultMessage')}</Typography>
          <Typography variant="body2" color="text.secondary">
            {t('accruals:forceUpdateConfirm.question')}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('common:cancel')}</Button>
        <LoadingButton variant="contained" loading={isConfirming} onClick={handleConfirm}>
          {t('common:continueText')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
